import { createAction, props } from '@ngrx/store';
import { MemberFeeFullPrice } from '../../../../../../models/member/member-fee/member-fee-full-price';

export const listMemberFeesHash = createAction(
    '[MemberFees] list',
    props <{idMemberHash: string}>()
);

export const listMemberFeesHashSuccess = createAction(
    '[MemberFees] list success',
    props <{listMemberFees: MemberFeeFullPrice[]}>()
);

export const resetListMemberFeesHash = createAction(
    '[MemberFees] list reset'
);
